import PendoButton from '../button/pendo-button.vue.js';
import PendoCollapseTransition from '../../utils/pendo-collapse-transition.vue.js';

var script = {
  name: 'PendoCardSection',
  components: {
    PendoButton,
    PendoCollapseTransition
  },
  props: {
    closable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: false
    };
  },
  mounted() {
    this.isVisible = true;
    if (this.$el.parentNode && this.$el.parentNode.classList[0] === 'pendo-card__body') {
      this.$el.parentNode.style.padding = 0;
    }
  },
  methods: {
    removeSelf() {
      this.isVisible = false;
      setTimeout(() => {
        this.$emit('close');
        if (this.$el.parentNode) {
          this.$el.parentNode.removeChild(this.$el);
        }
        this.$destroy();
      }, 250);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-card-section.vue2.js.map
